<template>
  <div class="container-fluid">

    <div v-for="err in errors" :key="err.field" class="alert alert-danger">
      {{err.value}}
    </div>

    <h4 class="m-3">Добавление преимущества</h4>

    <el-form ref="form" :model="form" label-width="120px" id="uploadForm" name="uploadForm">
        <el-form-item label="Название">
            <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-form-item label="Сортировка">
            <el-input v-model="form.sort"></el-input>
        </el-form-item>

        <el-form-item label="Активность">
            <el-checkbox v-model="form.activity"></el-checkbox>
        </el-form-item>

        <el-form-item label="Изображение">
          <el-upload
          action=""
          list-type="picture"
          :limit="1"
          :auto-upload="false"
          :on-change="handleChange"
          >
            <el-button size="small" type="primary">Добавить Изображение</el-button>
          </el-upload>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" @click="storeAdvantage()">Добавить</el-button>
            <el-button @click="back()">Отмена</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import getErrors from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'

export default {
  data: function (){
    return {
      form: {
        title: '',
        sort: 0,
        activity: true,
        image: '',
      },
      errors: [],
      status: 0,
    }
  },
  methods:{
    back(){
        this.$router.go(-1);
    },
    storeAdvantage(){
      const { execute } = useFormData()

      const data = execute().setFields([
        'image',
        'title',
        'activity',
        'sort'
      ]).getFormData(this.form)


      axios.post('advantage',data).then(()=>{
          this.back()
      }).catch((errors)=>{
          if(errors.response.status === 401){
              this.$router.push('/login');
          }
          if(errors.response.status === 422) {
            this.setErrors(errors.response.data.errors)
          }
      });
    },
    handleChange(v){
      this.form.image = v?.raw || undefined
    },
    setErrors(err) {
      this.errors = getErrors(err)
    }
  }
}
</script>
